import React, { FC } from 'react';
import * as classes from './GalleryPictureItem.module.scss';
import cn from 'classnames';
import ShineHover from '../ShineHover/ShineHover';

interface Props {
  image: string;
  description?: string;
  rounded?: boolean;
}

const GalleryPictureItem: FC<Props> = ({ image, description, rounded }) => {
  return (
    <div className={classes.wrapper}>
      <ShineHover>
        <img src={image} alt={''} className={cn(rounded && classes.rounded)} />
      </ShineHover>
      <div className={classes.description}>{description}</div>
    </div>
  );
};

export default GalleryPictureItem;
